<template>
  <div v-if="this.$store.getters.isAdmin">
    <v-tabs
      v-model="selectedTab"
      background-color="pink lighten-2"
      grow
      icons-and-text
      dark
      class="mb-10"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-partners">
        <p style="font-weight:600">Partenaires</p >
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item value="tab-partners">
        <Partners></Partners>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<style lang="scss">
  @import "@/assets/sass/pages/error/error-6.scss";
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Partners from "@/components/admin/partner/tabPartners.vue";

export default {
  name: "partnerManagement",
  components: {
    Partners
  },
  data: ()=> ({
    selectedTab: null,
  }),
    watch: {
    selectedTab(value) {
      localStorage.selectedTab = value;
    }
  },
  mounted() {
    if (localStorage.selectedTab) {
       this.selectedTab = localStorage.selectedTab;
    } 
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration" },
      { title: "Gestion des partenaires" },
    ]);
  },
};
</script>
